"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Esignature = void 0;
var ESignV3_1 = require("@CommonFrontend/AcceptFlow/ESign/ESignV3");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var react_1 = __importStar(require("react"));
var react_final_form_1 = require("react-final-form");
var styles = __importStar(require("./Esignature.css"));
var signature_pad_1 = __importDefault(require("signature_pad"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var lodash_1 = require("lodash");
var AcceptFlowContextProvider_1 = require("@CommonFrontend/AcceptFlow/AcceptFlowContextProvider");
var SHOW_DEBUG_PREVIEW = false;
var initialiseCanvas = function (canvas) {
    var canvasContext = canvas.getContext("2d");
    if (canvas && canvasContext) {
        canvasContext.clearRect(0, 0, canvas.width, canvas.height);
        var ratio = ESignV3_1.PIXEL_RATIO;
        canvas.width = canvas.offsetWidth * ratio;
        canvas.height = canvas.offsetHeight * ratio;
        canvasContext.scale(ratio, ratio);
    }
};
var Esignature = function () {
    var isPrintMode = (0, AcceptFlowContextProvider_1.useAcceptFlowContext)().isPrintMode;
    var formContext = (0, react_1.useContext)(kaleidoscope_1.FormContext);
    if (isPrintMode) {
        return react_1.default.createElement(PrintableEsignature, null);
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_final_form_1.Field, { name: "esignature", initialValue: "", validate: function (value) {
                if (!value) {
                    return "Please sign to accept the quote";
                }
            }, parse: lodash_1.identity }, function (fieldProps) {
            var _a;
            var error = ((_a = fieldProps.meta.data) === null || _a === void 0 ? void 0 : _a.showValidationErrors) ? fieldProps.meta.error : undefined;
            return (react_1.default.createElement(SignatureComponent, { onBlur: function () {
                    fieldProps.input.onBlur();
                }, onFocus: function () {
                    fieldProps.input.onFocus();
                }, onChange: function (signature, method) {
                    var _a;
                    fieldProps.input.onChange(signature);
                    (_a = formContext === null || formContext === void 0 ? void 0 : formContext.form) === null || _a === void 0 ? void 0 : _a.change("signatureMethod", method);
                }, error: error }));
        }),
        react_1.default.createElement(kaleidoscope_1.ValidationSpy, { name: "esignature", mutators: formContext === null || formContext === void 0 ? void 0 : formContext.mutators })));
};
exports.Esignature = Esignature;
var SignatureComponent = function (_a) {
    var _b, _c;
    var onFocus = _a.onFocus, onBlur = _a.onBlur, onChange = _a.onChange, formError = _a.error;
    var _d = __read((0, react_1.useState)(ESignV3_1.SignatureTab.Type), 2), currentTab = _d[0], setCurrentTab = _d[1];
    var _e = __read((0, react_1.useState)(""), 2), typeSignature = _e[0], setTypeSignature = _e[1];
    var _f = __read((0, react_1.useState)(""), 2), typeSignatureData = _f[0], setTypeSignatureData = _f[1];
    var _g = __read((0, react_1.useState)(false), 2), drawSignatureIsDirty = _g[0], setDrawSignatureIsDirty = _g[1];
    var _h = __read((0, react_1.useState)(""), 2), drawSignatureData = _h[0], setDrawSignatureData = _h[1];
    var _j = __read((0, react_1.useState)(false), 2), hasUploadedImage = _j[0], setHasUploadedImage = _j[1];
    var _k = __read((0, react_1.useState)(""), 2), uploadSignatureData = _k[0], setUploadSignatureData = _k[1];
    var _l = __read((0, react_1.useState)(undefined), 2), uploadError = _l[0], setUploadError = _l[1];
    var _m = __read((0, react_1.useState)(false), 2), isDraggingOverUpload = _m[0], setIsDraggingOverUpload = _m[1];
    var typeCanvasRef = (0, react_1.useRef)(null);
    var drawCanvasRef = (0, react_1.useRef)(null);
    var uploadCanvasRef = (0, react_1.useRef)(null);
    var signaturePadRef = (0, react_1.useRef)();
    var uploadedSignatureImageRef = (0, react_1.useRef)();
    var chooseImageForUpload = function () { return __awaiter(void 0, void 0, void 0, function () {
        var tempUpload;
        return __generator(this, function (_a) {
            tempUpload = document.createElement("input");
            tempUpload.type = "file";
            tempUpload.accept = "image/png, image/jpeg";
            tempUpload.style.display = "none";
            tempUpload.addEventListener("change", function (event) { return __awaiter(void 0, void 0, void 0, function () {
                var files;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            files = event.target.files;
                            if (!files) return [3, 2];
                            return [4, handleUploadImage(files)];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            document.body.removeChild(tempUpload);
                            return [2];
                    }
                });
            }); });
            document.body.appendChild(tempUpload);
            tempUpload.click();
            return [2];
        });
    }); };
    var currentTabSignature = (0, react_1.useMemo)(function () {
        var _a;
        return (_a = {},
            _a[ESignV3_1.SignatureTab.Type] = typeSignatureData,
            _a[ESignV3_1.SignatureTab.Draw] = drawSignatureData,
            _a[ESignV3_1.SignatureTab.Upload] = uploadSignatureData,
            _a)[currentTab];
    }, [currentTab, drawSignatureData, typeSignatureData, uploadSignatureData]);
    (0, react_1.useEffect)(function () {
        var _a;
        if (currentTab === ESignV3_1.SignatureTab.Draw) {
            var canvas = drawCanvasRef.current;
            if (canvas) {
                signaturePadRef.current = new signature_pad_1.default(canvas, {
                    penColor: "#242C39",
                    onBegin: onFocus,
                    onEnd: function () {
                        updateDrawnSignature();
                        onBlur();
                    },
                });
                initialiseCanvas(canvas);
                signaturePadRef.current.fromDataURL(drawSignatureData, {
                    width: canvas.width / ESignV3_1.PIXEL_RATIO,
                    height: canvas.height / ESignV3_1.PIXEL_RATIO,
                });
            }
        }
        else if (currentTab === ESignV3_1.SignatureTab.Upload) {
            updateUploadSignature();
        }
        var method = (_a = {},
            _a[ESignV3_1.SignatureTab.Type] = ESignV3_1.SignatureInputMethod.Typed,
            _a[ESignV3_1.SignatureTab.Draw] = ESignV3_1.SignatureInputMethod.Drawn,
            _a[ESignV3_1.SignatureTab.Upload] = ESignV3_1.SignatureInputMethod.Uploaded,
            _a)[currentTab];
        onChange(currentTabSignature, method);
    }, [currentTab]);
    var error = uploadError !== null && uploadError !== void 0 ? uploadError : formError;
    var updateTypeSignature = function (newValue) {
        if (!newValue) {
            setTypeSignature("");
            setTypeSignatureData("");
            onChange("", ESignV3_1.SignatureInputMethod.Typed);
        }
        else {
            setTypeSignature(newValue);
            var canvas = typeCanvasRef.current;
            var canvasContext = canvas === null || canvas === void 0 ? void 0 : canvas.getContext("2d");
            if (canvas && canvasContext) {
                initialiseCanvas(canvas);
                var fontSize = ESignV3_1.STANDARD_SCREEN_TEXT_SIGNATURE_FONT_SIZE;
                var padding = ESignV3_1.STANDARD_SCREEN_TEXT_SIGNATURE_PADDING;
                if (window.innerWidth <= ESignV3_1.SMALL_SCREEN_BREAKPOINT) {
                    fontSize = ESignV3_1.SMALL_SCREEN_TEXT_SIGNATURE_FONT_SIZE;
                    padding = ESignV3_1.SMALL_SCREEN_TEXT_SIGNATURE_PADDING;
                }
                canvasContext.font = "".concat(fontSize, "px Damion");
                canvasContext.fillStyle = "#242C39";
                canvasContext.fillText(newValue, padding, canvas.height / ESignV3_1.PIXEL_RATIO - padding - 14, canvas.width / ESignV3_1.PIXEL_RATIO - padding * 2);
                var signatureData = canvas.toDataURL();
                setTypeSignatureData(signatureData);
                onChange(signatureData, ESignV3_1.SignatureInputMethod.Typed);
            }
            else {
                throw new Error("Unable to update signature: couldn't find canvas");
            }
        }
    };
    var updateDrawnSignature = function () {
        var _a, _b, _c, _d;
        var signatureData = (_b = (_a = signaturePadRef.current) === null || _a === void 0 ? void 0 : _a.toDataURL()) !== null && _b !== void 0 ? _b : "";
        var isEmpty = (_d = (_c = signaturePadRef.current) === null || _c === void 0 ? void 0 : _c.isEmpty()) !== null && _d !== void 0 ? _d : true;
        if (isEmpty) {
            setDrawSignatureIsDirty(false);
            setDrawSignatureData("");
            onChange("", ESignV3_1.SignatureInputMethod.Drawn);
        }
        else {
            setDrawSignatureIsDirty(true);
            setDrawSignatureData(signatureData);
            onChange(signatureData, ESignV3_1.SignatureInputMethod.Drawn);
        }
    };
    var updateUploadSignature = function () { return __awaiter(void 0, void 0, void 0, function () {
        var canvas, canvasContext, image, canvasRatio, imageRatio, relativeRatio, canvasWidth, canvasHeight, proportionalWidth, proportionalHeight, signature;
        return __generator(this, function (_a) {
            canvas = uploadCanvasRef.current;
            canvasContext = canvas === null || canvas === void 0 ? void 0 : canvas.getContext("2d");
            image = uploadedSignatureImageRef.current;
            if (canvas && canvasContext) {
                initialiseCanvas(canvas);
                if (image) {
                    canvasRatio = canvas.width / canvas.height;
                    imageRatio = image.width / image.height;
                    relativeRatio = canvasRatio > imageRatio ? "tall" : "wide";
                    canvasWidth = canvas.width / ESignV3_1.PIXEL_RATIO;
                    canvasHeight = canvas.height / ESignV3_1.PIXEL_RATIO;
                    if (relativeRatio === "tall") {
                        proportionalWidth = imageRatio / canvasRatio;
                        canvasContext.drawImage(image, (canvasWidth - proportionalWidth * canvasWidth) / 2, 0, (proportionalWidth * canvas.width) / ESignV3_1.PIXEL_RATIO, canvasHeight);
                    }
                    else {
                        proportionalHeight = canvasRatio / imageRatio;
                        canvasContext.drawImage(image, 0, (canvasHeight - proportionalHeight * canvasHeight) / 2, canvasWidth, proportionalHeight * canvasHeight);
                    }
                    signature = canvas.toDataURL();
                    setUploadSignatureData(signature);
                    setHasUploadedImage(true);
                    onChange(signature, ESignV3_1.SignatureInputMethod.Uploaded);
                }
                else {
                    setUploadSignatureData("");
                    setHasUploadedImage(false);
                    onChange("", ESignV3_1.SignatureInputMethod.Uploaded);
                }
            }
            return [2];
        });
    }); };
    var handleUploadImage = function (files) { return __awaiter(void 0, void 0, void 0, function () {
        var file, tempImage;
        return __generator(this, function (_a) {
            if (files.length === 0) {
                return [2];
            }
            file = files[0];
            if (!["image/png", "image/jpeg"].includes(file.type)) {
                setUploadError("File must be a .png or .jpeg");
                return [2];
            }
            if (file.size > ESignV3_1.MAX_UPLOAD_SIZE_IN_MB * ESignV3_1.MB_IN_BYTES) {
                setUploadError("File must be less than ".concat(ESignV3_1.MAX_UPLOAD_SIZE_IN_MB, "MB"));
                return [2];
            }
            setUploadError(undefined);
            tempImage = new Image();
            tempImage.onload = function () { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            uploadedSignatureImageRef.current = tempImage;
                            return [4, updateUploadSignature()];
                        case 1:
                            _a.sent();
                            setIsDraggingOverUpload(false);
                            return [2];
                    }
                });
            }); };
            tempImage.src = URL.createObjectURL(files[0]);
            return [2];
        });
    }); };
    var currentTabIsPopulated = (_b = {},
        _b[ESignV3_1.SignatureTab.Type] = !!typeSignature,
        _b[ESignV3_1.SignatureTab.Draw] = drawSignatureIsDirty,
        _b[ESignV3_1.SignatureTab.Upload] = hasUploadedImage,
        _b)[currentTab];
    return (react_1.default.createElement(kaleidoscope_1.Stack, { gap: "xs", className: styles.signatureContainer },
        react_1.default.createElement(kaleidoscope_1.Stack, { justify: "spaceBetween", direction: "horizontal" },
            react_1.default.createElement(kaleidoscope_1.Label, { className: styles.label }, "E-signature"),
            react_1.default.createElement(kaleidoscope_1.Label, { className: styles.label }, new Date(Date.now()).toLocaleDateString())),
        react_1.default.createElement("div", { className: styles.card({ invalid: !!error }), onFocus: onFocus },
            react_1.default.createElement(kaleidoscope_1.Tabs, { selectedIndex: ESignV3_1.orderedSignatureTabs.indexOf(currentTab), onChange: function (tabIndex) {
                    onFocus();
                    var tab = ESignV3_1.orderedSignatureTabs[tabIndex];
                    signaturePadRef.current = undefined;
                    setUploadError(undefined);
                    setCurrentTab(tab);
                } },
                react_1.default.createElement("div", { className: styles.cardHeader },
                    react_1.default.createElement(kaleidoscope_1.TabList, { "aria-label": "Signature type" },
                        react_1.default.createElement(kaleidoscope_1.Tab, null, "Type"),
                        react_1.default.createElement(kaleidoscope_1.Tab, null, "Draw"),
                        react_1.default.createElement(kaleidoscope_1.Tab, null, "Upload")),
                    react_1.default.createElement("div", { className: styles.actions },
                        react_1.default.createElement(kaleidoscope_1.Button, { type: kaleidoscope_1.ButtonType.Tertiary, size: kaleidoscope_1.ButtonSize.Small, disabled: !currentTabIsPopulated, onClick: function (event) {
                                var _a;
                                event.preventDefault();
                                if (currentTab === ESignV3_1.SignatureTab.Type) {
                                    updateTypeSignature("");
                                }
                                if (currentTab === ESignV3_1.SignatureTab.Draw) {
                                    (_a = signaturePadRef.current) === null || _a === void 0 ? void 0 : _a.clear();
                                    updateDrawnSignature();
                                }
                                if (currentTab === ESignV3_1.SignatureTab.Upload) {
                                    uploadedSignatureImageRef.current = undefined;
                                    updateUploadSignature();
                                }
                                onBlur();
                            } }, "Clear"))),
                react_1.default.createElement(kaleidoscope_1.TabPanels, { transitionHeight: true },
                    react_1.default.createElement(kaleidoscope_1.TabPanel, { className: styles.tabPanel({ mode: "type" }) },
                        react_1.default.createElement("div", { className: styles.inputWrapper },
                            react_1.default.createElement("input", { className: styles.input, placeholder: "Type your signature", value: typeSignature, onChange: function (e) {
                                    var value = e.target.value;
                                    updateTypeSignature(value);
                                }, "data-qwilr-component": "esignature-type", onFocus: onFocus, onBlur: onBlur })),
                        react_1.default.createElement("canvas", { ref: typeCanvasRef, className: styles.canvas({ mode: "type" }) })),
                    react_1.default.createElement(kaleidoscope_1.TabPanel, { className: styles.tabPanel({ mode: "draw" }) },
                        react_1.default.createElement("div", { className: styles.inputWrapper },
                            react_1.default.createElement("div", { className: styles.input })),
                        react_1.default.createElement("canvas", { ref: drawCanvasRef, id: "e-signature-draw", className: styles.canvas({ mode: "draw" }) })),
                    react_1.default.createElement(kaleidoscope_1.TabPanel, { className: styles.tabPanel({ mode: "upload" }) },
                        react_1.default.createElement("div", { className: styles.uploadWrapper({ hasUploaded: hasUploadedImage }), onDragOver: function (event) {
                                event.preventDefault();
                                event.stopPropagation();
                                event.dataTransfer.dropEffect = "copy";
                                setIsDraggingOverUpload(true);
                            }, onDragLeave: function () {
                                setIsDraggingOverUpload(false);
                            }, onDrop: function (event) { return __awaiter(void 0, void 0, void 0, function () {
                                var files;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            event.preventDefault();
                                            files = event.dataTransfer.files;
                                            return [4, handleUploadImage(files)];
                                        case 1:
                                            _a.sent();
                                            onBlur();
                                            return [2];
                                    }
                                });
                            }); } },
                            react_1.default.createElement("div", { className: styles.upload({ draggedOver: isDraggingOverUpload }) },
                                react_1.default.createElement("div", { className: styles.uploadDescription },
                                    react_1.default.createElement("div", { className: "text-medium-label" }, "Drag a file here"),
                                    react_1.default.createElement("div", { className: "text-description" }, "Must be a .png or .jpg")),
                                react_1.default.createElement(kaleidoscope_1.Button, { type: kaleidoscope_1.ButtonType.Secondary, size: kaleidoscope_1.ButtonSize.Small, onClick: function (event) {
                                        event.preventDefault();
                                        onFocus();
                                        chooseImageForUpload();
                                    } }, "Browse files"))),
                        react_1.default.createElement("canvas", { ref: uploadCanvasRef, className: styles.canvas({ mode: "upload", hasUploaded: hasUploadedImage }) }))))),
        react_1.default.createElement(kaleidoscope_1.Expandable, { expanded: !!error, timeout: kaleidoscope_1.AnimationDuration.Short, "aria-live": "polite" }, function (_a) {
            var expandableElementRef = _a.expandableElementRef;
            return (react_1.default.createElement("div", { ref: expandableElementRef, className: styles.error },
                react_1.default.createElement(icons_1.Warning, { "aria-hidden": true, size: icons_1.IconSize.Small, className: styles.errorIcon }),
                react_1.default.createElement(kaleidoscope_1.Text, { size: "s", className: styles.errorText, "aria-live": "polite" }, error)));
        }),
        SHOW_DEBUG_PREVIEW && (react_1.default.createElement("div", null,
            react_1.default.createElement("div", { style: { color: "blue" } },
                "Current tab: ",
                currentTab),
            react_1.default.createElement("img", { style: { outline: "1px solid blue" }, src: (_c = {},
                    _c[ESignV3_1.SignatureTab.Type] = typeSignatureData,
                    _c[ESignV3_1.SignatureTab.Draw] = drawSignatureData,
                    _c[ESignV3_1.SignatureTab.Upload] = uploadSignatureData,
                    _c)[currentTab] })))));
};
var PrintableEsignature = function () {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(kaleidoscope_1.TextInput, { label: "Signature", size: kaleidoscope_1.TextInputSize.Small }),
        react_1.default.createElement(kaleidoscope_1.TextInput, { label: "Date", size: kaleidoscope_1.TextInputSize.Small })));
};
